import React, { useState, useEffect } from "react";
import Tab1Image from "../img/envision/aerospace/tabsimages/tabthree/ot&it.jpg";
import Tab2Image from "../img/envision/aerospace/tabsimages/tabthree/disaster recovery.jpg";
import Tab3Image from "../img/envision/aerospace/tabsimages/tabthree/secure.jpg";
import Tab4Image from "../img/envision/aerospace/tabsimages/tabthree/predictive.jpg";
import Tab5Image from "../img/envision/aerospace/tabsimages/tabthree/ai-enabled.jpg";
import Tab6Image from "../img/envision/aerospace/tabsimages/tabthree/clud.jpg";
import Tab7Image from "../img/envision/aerospace/tabsimages/jhkk.jpg";
import Tab8Image from "../img/envision/aerospace/tabsimages/futuristic-time-machine.jpg";
import Tab9Image from "../img/envision/aerospace/tabsimages/space-travel-collage-design.jpg";
import Tab10Image from "../img/envision/aerospace/ai-enabled.jpg";
import Tab11Image from "../img/envision/aerospace/cloud.jpg";


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCar, faTruck, faGear, faMicrochip, faSlidersH, faWifi, faCogs, faCloud, faVial, faTablet, faNetworkWired, faDesktop, faLaptop } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
const AeroVerticalTabss = () => {
  const [activeTab, setActiveTab] = useState("tab1");
const [isAutoPlayActive, setIsAutoPlayActive] = useState(true); // State to manage autoplay

  // const handleTabClick = (tabId) => {
  //   setActiveTab(tabId);
  // };
  const handleKnowMoreFirstClick = () => {
    navigate("/documentaerospacepage#AerospaceDocumentDatatabs");
  };

  const navigate = useNavigate(); // Initialize navigate

  const handleKnowMoreClick = () => {
    navigate("/documentaerospacepage#AerospaceDocumentDatatabs");
  };

  const [isHovered, setIsHovered] = useState(false);

 useEffect(() => {
        let tabInterval;
    
        if (!isHovered && isAutoPlayActive) {
          tabInterval = setInterval(() => {
            setActiveTab((prevTab) => {
              const nextTabNum = parseInt(prevTab.replace("tab", "")) % 9 + 1;
              return `tab${nextTabNum}`;
            });
          }, 3000);
        }
    
        return () => clearInterval(tabInterval);
      }, [activeTab, isHovered, isAutoPlayActive]);
    
    
      const handleTabClick = (tabId) => {
        setActiveTab(tabId);
        setIsAutoPlayActive(false); // Stop auto-play when tab is clicked
      };


  const styles = {
    container: {
      fontFamily: "Arial, sans-serif",
      width: "80%",
      margin: "50px auto",
    },
    tabNav: {

      flexDirection: "column",
      borderRight: "1px solid #fff",
      height: "400px",
      overflowY: "auto", // Ensure only vertical scrolling
      scrollbarWidth: "thin", // For Firefox
      scrollbarColor: "#ccc transparent", // For Firefox
      direction: "rtl", // This makes the scrollbar appear on the left side
    },

    tabButton: {
      padding: "15px",
      cursor: "pointer",
      border: "none",
      background: "none",
      fontSize: "16px",
      fontWeight: "bold",
      color: "#555",
      outline: "none",
      transition: "color 0.3s, background-color 0.3s",
      borderRadius: "10px",
      margin: "5px 0",
      backgroundColor: "#f0f0f0",
    },
    activeTabButton: {
      backgroundColor: "rgb(236 115 34)",
      color: "#fff",
    },
    card: {
      // display: "flex",
      alignItems: "center",
      padding: "20px",
      borderRadius: "15px",
      backgroundColor: "#fff",
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
      width: "100%",
      // marginLeft: "10px",
      cursor: "pointer",
      height: "400px",
      overflowY: "auto",
    },
    image: {
      width: "382px",
      height: "274px",
      borderRadius: "10px",
      marginRight: "20px",
      // marginTop:"-250px"
    },
    textContent: {
      flex: 1,
      textAlign: "justify !important",
      color: "#333",
      height:"1200px"
    },
    icon: {
      marginRight: "10px",
      fontSize: "24px",
      color: "#009ca5",
    },
    dotNav: {
      display: "flex",
      justifyContent: "center",
      marginTop: "10px",
    },
    dot: {
      width: "10px",
      height: "10px",
      borderRadius: "50%",
      backgroundColor: "#ccc",
      margin: "0 5px",
      cursor: "pointer",
      transition: "background-color 0.3s",
    },
    activeDot: {
      backgroundColor: "rgb(236 115 34)",
    },
    knowMoreButton: {
      marginTop: "15px",
      padding: "10px 20px",
      backgroundColor: "rgb(236 115 34)",
      color: "#fff",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      fontSize: "16px",
      transition: "background-color 0.3s",
      // marginLeft: "150px"
    },
    knowMoreButtonHover: {
      backgroundColor: "#e68a00",
    },
  };

  return (
    <div style={{ marginTop: "100px" }}>
      <h1 style={{ textAlign: "center" }}>
        <span style={{ color: "rgb(236 115 34)" }}>Gen AI Enabled IT & OT </span> Transformation
      </h1>
      <div style={styles.container}
        className="tabclass-container-data"
      >
        <div style={styles.tabNav} className="tabdata">
          <button
            style={{
              ...styles.tabButton,
              ...(activeTab === "tab1" ? styles.activeTabButton : {}),
            }}
            onClick={() => handleTabClick("tab1")}
            className="tab-button-width"
            onMouseEnter={(e) => {
              if (activeTab !== "tab1") {
                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                e.currentTarget.style.color = "#fff"; // Change text to white
              }
            }}
            onMouseLeave={(e) => {
              if (activeTab !== "tab1") {
                e.currentTarget.style.backgroundColor = ""; // Revert background
                e.currentTarget.style.color = ""; // Revert text color
              }
            }}
          >
            IT & OT Infrastructure transformation
          </button>
          <button
            style={{
              ...styles.tabButton,
              ...(activeTab === "tab2" ? styles.activeTabButton : {}),
            }}
            onClick={() => handleTabClick("tab2")}
            className="tab-button-width"
            onMouseEnter={(e) => {
              if (activeTab !== "tab2") {
                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                e.currentTarget.style.color = "#fff"; // Change text to white
              }
            }}
            onMouseLeave={(e) => {
              if (activeTab !== "tab2") {
                e.currentTarget.style.backgroundColor = ""; // Revert background
                e.currentTarget.style.color = ""; // Revert text color
              }
            }}
          >
            Disaster Recovery & Business Continuity
          </button>
          <button
            style={{
              ...styles.tabButton,
              ...(activeTab === "tab3" ? styles.activeTabButton : {}),
            }}
            onClick={() => handleTabClick("tab3")}
            className="tab-button-width"
            onMouseEnter={(e) => {
              if (activeTab !== "tab3") {
                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                e.currentTarget.style.color = "#fff"; // Change text to white
              }
            }}
            onMouseLeave={(e) => {
              if (activeTab !== "tab3") {
                e.currentTarget.style.backgroundColor = ""; // Revert background
                e.currentTarget.style.color = ""; // Revert text color
              }
            }}
          >
           Transformed Applications (ERP Transformation, IT Modernization)
          </button>
          <button
            style={{
              ...styles.tabButton,
              ...(activeTab === "tab4" ? styles.activeTabButton : {}),
            }}
            onClick={() => handleTabClick("tab4")}
            className="tab-button-width"
            onMouseEnter={(e) => {
              if (activeTab !== "tab4") {
                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                e.currentTarget.style.color = "#fff"; // Change text to white
              }
            }}
            onMouseLeave={(e) => {
              if (activeTab !== "tab4") {
                e.currentTarget.style.backgroundColor = ""; // Revert background
                e.currentTarget.style.color = ""; // Revert text color
              }
            }}
          >
          Cloud Adoption & AI-Driven Cloud Security
          </button>
          <button
            style={{
              ...styles.tabButton,
              ...(activeTab === "tab5" ? styles.activeTabButton : {}),
            }}
            onClick={() => handleTabClick("tab5")}
            className="tab-button-width"
            onMouseEnter={(e) => {
              if (activeTab !== "tab5") {
                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                e.currentTarget.style.color = "#fff"; // Change text to white
              }
            }}
            onMouseLeave={(e) => {
              if (activeTab !== "tab5") {
                e.currentTarget.style.backgroundColor = ""; // Revert background
                e.currentTarget.style.color = ""; // Revert text color
              }
            }}
          >
         Business-Aligned IT & Security
          </button>
          <button
            style={{
              ...styles.tabButton,
              ...(activeTab === "tab6" ? styles.activeTabButton : {}),
            }}
            onClick={() => handleTabClick("tab6")}
            className="tab-button-width"
            onMouseEnter={(e) => {
              if (activeTab !== "tab6") {
                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                e.currentTarget.style.color = "#fff"; // Change text to white
              }
            }}
            onMouseLeave={(e) => {
              if (activeTab !== "tab6") {
                e.currentTarget.style.backgroundColor = ""; // Revert background
                e.currentTarget.style.color = ""; // Revert text color
              }
            }}
          >
            Secured & Modern OT Infrastructure
          </button>
          <button
            style={{
              ...styles.tabButton,
              ...(activeTab === "tab7" ? styles.activeTabButton : {}),
            }}
            onClick={() => handleTabClick("tab7")}
            className="tab-button-width"
            onMouseEnter={(e) => {
              if (activeTab !== "tab7") {
                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                e.currentTarget.style.color = "#fff"; // Change text to white
              }
            }}
            onMouseLeave={(e) => {
              if (activeTab !== "tab7") {
                e.currentTarget.style.backgroundColor = ""; // Revert background
                e.currentTarget.style.color = ""; // Revert text color
              }
            }}
          >
            Predictive Maintenance & AI-Driven Asset Optimization
          </button>
          <button
            style={{
              ...styles.tabButton,
              ...(activeTab === "tab8" ? styles.activeTabButton : {}),
            }}
            onClick={() => handleTabClick("tab8")}
            className="tab-button-width"
            onMouseEnter={(e) => {
              if (activeTab !== "tab8") {
                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                e.currentTarget.style.color = "#fff"; // Change text to white
              }
            }}
            onMouseLeave={(e) => {
              if (activeTab !== "tab8") {
                e.currentTarget.style.backgroundColor = ""; // Revert background
                e.currentTarget.style.color = ""; // Revert text color
              }
            }}
          >
            AI-Enabled Industrial Automation & Smart Manufacturing
          </button>
          <button
            style={{
              ...styles.tabButton,
              ...(activeTab === "tab9" ? styles.activeTabButton : {}),
            }}
            onClick={() => handleTabClick("tab9")}
            className="tab-button-width"
            onMouseEnter={(e) => {
              if (activeTab !== "tab9") {
                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                e.currentTarget.style.color = "#fff"; // Change text to white
              }
            }}
            onMouseLeave={(e) => {
              if (activeTab !== "tab9") {
                e.currentTarget.style.backgroundColor = ""; // Revert background
                e.currentTarget.style.color = ""; // Revert text color
              }
            }}
          >
            Cloud-Enabled OT & AI-Driven Edge Computing
          </button>
        </div>


        <div style={styles.card} className="card-data-vertica-tabs"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <img
            src={{ tab1: Tab1Image, tab2: Tab2Image, tab3: Tab3Image, tab4: Tab4Image, tab5: Tab5Image, tab6: Tab6Image, tab7: Tab7Image,tab8: Tab10Image,tab9: Tab10Image, }[activeTab]}
            alt="Healthcare"
            style={styles.image}
            className="tab-image-data"
          />
         

          <div style={styles.textContent}>
            {/* Render content based on the activeTab */}
            <p
              style={{
                textAlign: "justify",
                whiteSpace: "pre-line",
              }}
              className="aerothirdtab"
              dangerouslySetInnerHTML={{
                __html: [
                  `<strong><ul><li>Problem:</li></ul></strong> <ul><li>Aerospace organizations face increasing cybersecurity threats, legacy system vulnerabilities, and regulatory compliance challenges (ISO 27001, NIST 800-171, CMMC). Outdated network security architectures struggle to handle modern AI-driven threats, insider risks, and evolving cyberattacks targeting aerospace IT and operational technology (OT) environments.</li></ul> <strong><ul><li>How DREBCON Can Help: </li></ul></strong> <ul><li>DREBCON offers Gen AI-powered cybersecurity solutions, including AI-driven threat detection, self-healing networks, and automated compliance management. Our zero-trust security framework, AI-enhanced intrusion detection, and real-time security monitoring ensure that aerospace IT infrastructure remains secured, resilient, and future-proof. </li></ul><strong><ul><li> Result:</li></ul></strong> <ul><li>Organizations achieve a fully secured and modern IT infrastructure, with reduced cyber risks, real-time compliance tracking, and AI-driven predictive security. This ensures resilient aerospace operations, regulatory compliance, and uninterrupted IT performance.</li></ul>`,

                  `<strong><ul><li>Problem:</li></ul></strong><ul><li> Aerospace enterprises struggle with business continuity risks due to cyber threats, system failures, and lack of real-time disaster recovery (DR) automation. Traditional manual recovery processes lead to extended downtime, financial losses, and operational disruptions in critical aerospace systems.</li></ul> <strong><ul><li>How DREBCON Can Help: </li></ul></strong> <ul><li> DREBCON provides AI-powered disaster recovery automation, enabling real-time data replication, predictive failure detection, and automated backup validation. Our cloud-based AI-driven DR solutions ensure continuous availability and seamless failover mechanisms for mission-critical aerospace applications. </li></ul><strong><ul><li>Result: </li></ul></strong> <ul><li> Organizations gain resilient disaster recovery with automated failover, reduced downtime, and business continuity readiness. AI-driven risk modeling helps predict disruptions, ensuring minimal financial loss and uninterrupted aerospace operations.</li></ul>`,
                  
                  `<strong><ul><li>Problem:</li></ul></strong><ul><li> Aerospace organizations rely on outdated ERP and IT systems that lack AI-driven automation, predictive analytics, and real-time decision-making. Legacy applications increase operational inefficiencies, cybersecurity vulnerabilities, and integration challenges with modern AI solutions. </li></ul> <strong><ul><li>How DREBCON Can Help: </li></ul></strong> <ul><li> DREBCON accelerates ERP and IT transformation with AI-driven analytics, automated workflows, and intelligent decision support. We enable seamless migration to next-gen ERP solutions like SAP S/4HANA, Oracle ERP Cloud, and AI-powered CRM systems, optimizing supply chains and operations.</li></ul><strong><ul><li>Result: </li></ul></strong> <ul><li> Aerospace companies gain streamlined operations, AI-powered automation, and real-time data insights. This enhances operational efficiency, reduces IT costs, and improves decision-making for future-ready aerospace enterprises.</li></ul>`,
                  
                  `<strong><ul><li>Problem:</li></ul></strong> <ul><li>Many aerospace organizations struggle with cloud adoption due to security risks, multi-cloud complexity, and compliance challenges. Data sovereignty, hybrid cloud misconfigurations, and legacy system migration hurdles slow down digital transformation. </li></ul> <strong><ul><li>How DREBCON Can Help: </li></ul></strong> <ul><li> DREBCON enables secure, AI-driven cloud adoption with automated cloud migration, AI-enhanced multi-cloud security, and predictive resource optimization. Our cloud-native cybersecurity solutions protect aerospace data, applications, and network infrastructure across hybrid and multi-cloud environments. </li></ul><strong><ul><li>Result: </li></ul></strong> <ul><li> Organizations achieve seamless, secure, and scalable cloud adoption with real-time AI-driven cloud security monitoring, cost-optimized cloud infrastructure, and compliance-ready cloud governance. This enhances agility, operational efficiency, and cyber resilience.</li></ul>`,
                  
                  `<strong><ul><li>Problem:</li></ul></strong> <ul><li>Aerospace companies often operate siloed IT and security frameworks, leading to misaligned business objectives, inefficient security controls, and reactive cybersecurity strategies. Lack of AI-driven risk intelligence and predictive threat modeling limits proactive decision-making. </li></ul> <strong><ul><li>How DREBCON Can Help: </li></ul></strong> <ul><li> DREBCON aligns IT and security with business goals through AI-powered predictive security analytics, automated risk assessments, and real-time cybersecurity intelligence. Our Gen AI-driven Security Operations Center (SOC) ensures threat response automation, compliance enforcement, and strategic risk management.</li></ul><strong><ul><li>Result: </li></ul></strong> <ul><li>Organizations benefit from proactive cybersecurity, AI-driven risk intelligence, and business-aligned IT governance. This enables faster decision-making, improved regulatory compliance, and a secure digital transformation strategy for aerospace enterprises.</li></ul>`,

                  `<strong><ul><li>Problem:</li></ul></strong> <ul><li>Traditional OT environments in aerospace rely on legacy SCADA, PLC, and ICS systems that are vulnerable to cyber threats, operational failures, and data silos. Lack of AI-driven security frameworks makes them easy targets for ransomware, nation-state cyberattacks, and insider threats.</li></ul> <strong><ul><li>How DREBCON Can Help: </li></ul></strong> <ul><li> DREBCON provides AI-powered OT security with real-time anomaly detection, AI-driven network segmentation, and zero-trust OT security architectures. Our Gen AI-driven threat intelligence platform protects SCADA, ICS, and industrial networks against cyberattacks, malware, and system breaches. </li></ul><strong><ul><li>Result: </li></ul></strong> <ul><li> Organizations achieve a fully secured, resilient OT infrastructure with real-time threat detection, AI-powered automated response, and compliance with aerospace cybersecurity frameworks (IEC 62443, NIST 800-82, and DO-326A). This enables secure aerospace manufacturing, avionics, and flight control systems.</li></ul>`,

                  `<strong><ul><li>Problem:</li></ul></strong> <ul><li>Aerospace manufacturing and operations depend on complex machinery, aircraft systems, and industrial assets that require constant monitoring and maintenance. Unplanned downtime, high maintenance costs, and failure of critical aerospace assets lead to operational inefficiencies and financial losses. </li></ul> <strong><ul><li>How DREBCON Can Help: </li></ul></strong> <ul><li> DREBCON integrates Gen AI-powered predictive maintenance to monitor OT systems, aircraft engines, avionics, and manufacturing equipment in real time. AI-driven sensor data analytics, anomaly detection, and predictive failure analysis ensure proactive maintenance scheduling and automated system diagnostics. </li></ul><strong><ul><li>Result: </li></ul></strong> <ul><li> Organizations achieve near-zero unplanned downtime, reduced maintenance costs, and enhanced equipment lifecycle management. AI-driven insights optimize asset utilization, ensuring continuous aerospace operations without unexpected failures.</li></ul>`,

                  `<strong><ul><li>Problem:</li></ul></strong><ul><li> Aerospace manufacturing requires high precision, efficiency, and automation, but legacy OT systems lack real-time AI-driven process optimization. Manual operations, data silos, and inefficient supply chain logistics hinder smart factory transformation. </li></ul> <strong><ul><li>How DREBCON Can Help: </li></ul></strong> <ul><li> DREBCON deploys AI-powered industrial automation for aerospace smart manufacturing, digital twins, and autonomous robotic systems. Gen AI-driven machine learning models enhance production efficiency, automate workflows, and optimize manufacturing processes.  </li></ul><strong><ul><li>Result: </li></ul></strong> <ul><li> Aerospace manufacturers achieve higher productivity, reduced operational costs, and AI-driven process optimization. Smart aerospace factories leverage AI-powered robotics, digital twins, and real-time production analytics to enhance precision engineering and aerospace part manufacturing.</li></ul>`,

                  `<strong><ul><li>Problem:</li></ul></strong> <ul><li>Legacy OT systems are isolated from cloud environments, making real-time data processing, cross-facility coordination, and remote monitoring difficult. Traditional on-premise control systems lack AI-driven decision-making and real-time analytics. </li></ul> <strong><ul><li>How DREBCON Can Help: </li></ul></strong> <ul><li> DREBCON enables cloud-integrated OT environments by leveraging AI-powered edge computing, real-time data streaming, and AI-driven cloud security. Hybrid cloud OT frameworks allow aerospace enterprises to process real-time OT data securely while maintaining compliance with aerospace industry standards.  </li></ul><strong><ul><li>Result: </li></ul></strong> <ul><li> Organizations achieve real-time monitoring of aerospace manufacturing, flight control, and avionics data, improving efficiency, security, and decision-making. AI-powered cloud-based OT analytics ensures real-time diagnostics, predictive insights, and operational efficiency at scale.</li></ul>`,
                ][parseInt(activeTab.replace("tab", "")) - 1],
              }}
            ></p>


            <button
              style={styles.knowMoreButton}
              onClick={handleKnowMoreFirstClick}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#e68a00")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "rgb(236 115 34)")}
              className="know-more-btn"
            >
              Know More
            </button>
          </div>
        </div>
      </div>

      {/* Dot Navigation */}
      <div style={styles.dotNav}>
        {[...Array(9)].map((_, index) => {
          const tab = `tab${index + 1}`;
          return (
            <div
              key={tab}
              style={{
                ...styles.dot,
                ...(activeTab === tab ? styles.activeDot : {}),
              }}
              onClick={() => handleTabClick(tab)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default AeroVerticalTabss;
